module.exports = "/_next/static/resources/cca-square-9d39169091ebdc674495e61c00860f26.jpg";